import { Routes } from '@angular/router';
import { LoginPageComponent } from './modules/login-page/login-page.component';
import { ErrorPageComponent } from './modules/login-page/error/error-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { AuthCallbackComponent } from './screens/auth-callback/auth-callback.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  { path: 'auth-callback', component: AuthCallbackComponent },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/dashboard/dashboard-page.module').then(m => m.DashboardPageModule),
    data: { title: 'Dashboard' }
  },
  {
    path: 'finance',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/finance/finance.module').then(m => m.FinancePageModule),
    data: { title: 'Finance' }
  },
  {
    path: 'client',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/client/client-page.module').then(m => m.ClientPageModule),
    data: { title: 'Clients', breadcrumb: 'Clients' }
  },
  {
    path: 'team',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/team/team-page.module').then(m => m.TeamPageModule),
    data: { title: 'Team' }
  },
  {
    path: 'partner',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/partner/partner-page.module').then(m => m.PartnerPageModule),
    data: { title: 'Partner' }
  },
  {
    path: 'alert',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/alert/alert-page.module').then(m => m.AlertPageModule),
    data: { title: 'Alerts' }
  },
  {
    path: 'report',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/report/report-page.module').then(m => m.ReportPageModule),
    data: { title: 'Report' }
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/notifications/notifications-page.module').then(m => m.NotificationsPageModule),
    data: { title: 'Notifications' }
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/settings/settings-page.module').then(m => m.SettingsPageModule),
    data: { title: 'Settings' }
  },
  {
    path: 'userprofile',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/userprofile/userprofile-page.module').then(m => m.UserprofilePageModule),
    data: { title: 'User Profile' }
  },
  { path: 'error', component: ErrorPageComponent },
  { path: '**', redirectTo: 'login' }
];
